import type Store from "@ember-data/store";
import type ApplicationInstance from "@ember/application/instance";
import type ConsultationAllowedType from "parog-web/models/consultation-allowed-type";

export function initialize(owner: ApplicationInstance): void {
  const store = owner.lookup("service:store") as Store;
  const consultationAllowedTypesRecords = {};

  const allowedTypes = [
    {
      id: "03-cardiologist-consultation",
      provider: {
        specialtySourceLabel: "Cardiologue",
        specialtySourceValue: "03"
      },
      procedure: {
        sourceLabel: "Consultation Cardiologue",
        sourceValue: "cardiologist-consultation"
      }
    },
    {
      id: "08-hepatologist-consultation",
      provider: {
        specialtySourceLabel: "Hépatologue",
        specialtySourceValue: "08"
      },
      procedure: {
        sourceLabel: "Consultation Hépatologie",
        sourceValue: "hepatologist-consultation"
      }
    },
    {
      id: "10/SM24-gastroenterologist-consultation",
      provider: {
        specialtySourceLabel: "Gastro-entérologue",
        specialtySourceValue: "10/SM24"
      },
      procedure: {
        sourceLabel: "Consultation gastro-entérologue",
        sourceValue: "gastroenterologist-consultation"
      }
    },
    {
      id: "13-pulmonologist-consultation",
      provider: {
        specialtySourceLabel: "Pneumologue",
        specialtySourceValue: "13"
      },
      procedure: {
        sourceLabel: "Consultation pneumologue",
        sourceValue: "pulmonologist-consultation"
      }
    },
    {
      id: "35-nephrologist-consultation",
      provider: {
        specialtySourceLabel: "Néphrologie",
        specialtySourceValue: "35"
      },
      procedure: {
        sourceLabel: "Consultation néphrologie",
        sourceValue: "nephrologist-consultation"
      }
    },
    {
      id: "01-doctor-consultation",
      provider: {
        specialtySourceLabel: "Médecine générale",
        specialtySourceValue: "01"
      },
      procedure: {
        sourceLabel: "Consultation médecin généraliste",
        sourceValue: "doctor-consultation"
      }
    },
    {
      id: "00-dietitian-consultation",
      provider: {
        specialtySourceLabel: "Diététique",
        specialtySourceValue: "00"
      },
      procedure: {
        sourceLabel: "Consultation diététicien",
        sourceValue: "dietitian-consultation"
      }
    },
    {
      id: "00-social-worker-consultation",
      provider: {
        specialtySourceLabel: "Assistante sociale",
        specialtySourceValue: "00"
      },
      procedure: {
        sourceLabel: "Consultation assistante sociale",
        sourceValue: "social-worker-consultation"
      }
    },
    {
      id: "71-announcement-consultation",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Consultation d'annonce",
        sourceValue: "announcement-consultation"
      }
    },
    {
      id: "71-sentinel-node-lymphoscinthigraphy",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Lymphoscinthigraphie ganglion sentinelle",
        sourceValue: "sentinel-node-lymphoscinthigraphy"
      }
    },
    {
      id: "71-ultrasound-spotting",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Repérage sous échographie",
        sourceValue: "ultrasound-spotting"
      }
    },
    {
      id: "71-anaesthetist-consultation",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Consultation anesthésiste",
        sourceValue: "anaesthetist-consultation"
      }
    },
    {
      id: "71-abdominal-ultrasound",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Echographie abdominale",
        sourceValue: "abdominal-ultrasound"
      }
    },
    {
      id: "71-echocardiography",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Echographie du coeur",
        sourceValue: "echocardiography"
      }
    },
    {
      id: "71-mri",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: { sourceLabel: "IRM", sourceValue: "mri" }
    },
    {
      id: "71-mammography",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: { sourceLabel: "Mammographie", sourceValue: "mammography" }
    },
    {
      id: "71-preoperative-nurse-appointment",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "RDV IDE pré-operatoire",
        sourceValue: "preoperative-nurse-appointment"
      }
    },
    {
      id: "71-scanner",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: { sourceLabel: "Scanner", sourceValue: "scanner" }
    },
    {
      id: "71-tracking-scanner",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Scanner de repérage",
        sourceValue: "tracking-scanner"
      }
    },
    {
      id: "71-bone-scan",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Scintigraphie osseuse",
        sourceValue: "bone-scan"
      }
    },
    {
      id: "71-computed-tomography",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "TDM Tomodensiometrie",
        sourceValue: "computed-tomography"
      }
    },
    {
      id: "71-addictologist",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: { sourceLabel: "Addictologue", sourceValue: "addictologist" }
    },
    {
      id: "71-respiratory-kine",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Kiné respiratoire",
        sourceValue: "respiratory-kine"
      }
    },
    {
      id: "71-dentist",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: { sourceLabel: "Dentiste", sourceValue: "dentist" }
    },
    {
      id: "71-psychologist",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: { sourceLabel: "Psychologue", sourceValue: "psychologist" }
    },
    {
      id: "71-social-worker",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Assistante sociale",
        sourceValue: "social-worker"
      }
    },
    {
      id: "71-ecg-consultation",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Electrocardiogramme",
        sourceValue: "ecg-consultation"
      }
    },
    {
      id: "71-intervention",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: { sourceLabel: "Intervention", sourceValue: "intervention" }
    },
    {
      id: "71-surgery-post-consultation",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Consultation post-chirurgie",
        sourceValue: "surgery-post-consultation"
      }
    },
    {
      id: "71-oncology-consultation",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Consultation oncologue",
        sourceValue: "oncology-consultation"
      }
    },
    {
      id: "71-targeted-therapy-end-date",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Fin thérapie ciblée",
        sourceValue: "targeted-therapy-end-date"
      }
    },
    {
      id: "71-targeted-therapy-start-date",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Début thérapie ciblée",
        sourceValue: "targeted-therapy-start-date"
      }
    },
    {
      id: "71-chemotherapy-therapy-one",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Chimiothérapie cure 1",
        sourceValue: "chemotherapy-therapy-one"
      }
    },
    {
      id: "71-chemotherapy-therapy-two",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Chimiothérapie cure 2",
        sourceValue: "chemotherapy-therapy-two"
      }
    },
    {
      id: "71-chemotherapy-therapy-four",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Chimiothérapie cure 4",
        sourceValue: "chemotherapy-therapy-four"
      }
    },
    {
      id: "71-chemotherapy-therapy-five",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Chimiothérapie cure 5",
        sourceValue: "chemotherapy-therapy-five"
      }
    },
    {
      id: "71-radiotherapy-consultation",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Consultation radiothérapeute",
        sourceValue: "radiotherapy-consultation"
      }
    },
    {
      id: "71-radiotherapy-start-date",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Début radiothérapie",
        sourceValue: "radiotherapy-start-date"
      }
    },
    {
      id: "71-radiotherapy-end-date",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Fin radiothérapie",
        sourceValue: "radiotherapy-end-date"
      }
    },
    {
      id: "71-hormonotherapy-start-date",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Début hormonothérapie",
        sourceValue: "hormonotherapy-start-date"
      }
    },
    {
      id: "71-hormonotherapy-end-date",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Fin hormonothérapie",
        sourceValue: "hormonotherapy-end-date"
      }
    },
    {
      id: "71-cp-appointment",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: { sourceLabel: "RDV CP", sourceValue: "cp-appointment" }
    },
    {
      id: "71-cure-injection",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Consultation pour cure en HDJ",
        sourceValue: "cure-injection"
      }
    },
    {
      id: "71-re-evaluation-scanner",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Scanner de réévaluation",
        sourceValue: "re-evaluation-scanner"
      }
    },
    {
      id: "71-remove-urinary-catheter",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Retrait de la sonde urinaire",
        sourceValue: "remove-urinary-catheter"
      }
    },
    {
      id: "71-post-operative-consultation",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Consultation post-opératoire",
        sourceValue: "post-operative-consultation"
      }
    },
    {
      id: "71-follow-up-consultation",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Consultation de suivi",
        sourceValue: "follow-up-consultation"
      }
    },
    {
      id: "71-primo-prescription",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Consultation de primo prescription",
        sourceValue: "primo-prescription"
      }
    },
    {
      id: "71-medication-reconciliation",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Consultation médicamenteuse",
        sourceValue: "medication-reconciliation"
      }
    },
    {
      id: "71-multiparty-consultation",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Consultation pluripartite",
        sourceValue: "multiparty-consultation"
      }
    },
    {
      id: "71-follow-up-consultation-with-prescription-renewal",
      provider: {
        specialtySourceLabel: "Oncologue",
        specialtySourceValue: "71"
      },
      procedure: {
        sourceLabel: "Consultation de suivi / Renouvellement de prescription",
        sourceValue: "follow-up-consultation-with-prescription-renewal"
      }
    }
  ];

  allowedTypes.forEach(allowed_type => {
    consultationAllowedTypesRecords[allowed_type.id] = store.createRecord(
      "consultation-allowed-type",
      allowed_type
    );
  });

  const followUpReasonAllowedTypes = {
    "cardio-heart-failure": ["03-cardiologist-consultation"],
    "cardio-transplant": ["03-cardiologist-consultation"],
    "cardio-generic": ["03-cardiologist-consultation"],
    "hepato-transplant": ["08-hepatologist-consultation"],
    "hepato-generic": ["08-hepatologist-consultation"],
    "digest-crohn": ["10/SM24-gastroenterologist-consultation"],
    "digest-rch": ["10/SM24-gastroenterologist-consultation"],
    "digest-generic": ["10/SM24-gastroenterologist-consultation"],
    "pneumo-transplant": ["13-pulmonologist-consultation"],
    "pneumo-generic": ["13-pulmonologist-consultation"],
    "nephro-donor": ["35-nephrologist-consultation"],
    "nephro-transplant": ["35-nephrologist-consultation"],
    "nephro-generic": [
      "35-nephrologist-consultation",
      "01-doctor-consultation",
      "00-dietitian-consultation",
      "00-social-worker-consultation"
    ],
    "nephro-mrc": [
      "35-nephrologist-consultation",
      "01-doctor-consultation",
      "00-dietitian-consultation",
      "00-social-worker-consultation"
    ],
    "onco-colon-cancer": [
      "71-announcement-consultation",
      "71-sentinel-node-lymphoscinthigraphy",
      "71-ultrasound-spotting",
      "71-anaesthetist-consultation",
      "71-abdominal-ultrasound",
      "71-echocardiography",
      "71-mri",
      "71-mammography",
      "71-preoperative-nurse-appointment",
      "71-scanner",
      "71-tracking-scanner",
      "71-bone-scan",
      "71-computed-tomography",
      "71-addictologist",
      "71-respiratory-kine",
      "71-dentist",
      "71-psychologist",
      "71-social-worker"
    ],
    "onco-ovarian-cancer": [
      "71-announcement-consultation",
      "71-sentinel-node-lymphoscinthigraphy",
      "71-ultrasound-spotting",
      "71-anaesthetist-consultation",
      "71-abdominal-ultrasound",
      "71-echocardiography",
      "71-mri",
      "71-mammography",
      "71-preoperative-nurse-appointment",
      "71-scanner",
      "71-tracking-scanner",
      "71-bone-scan",
      "71-computed-tomography",
      "71-addictologist",
      "71-respiratory-kine",
      "71-dentist",
      "71-psychologist",
      "71-social-worker"
    ],
    "onco-testicular-cancer": [
      "71-announcement-consultation",
      "71-sentinel-node-lymphoscinthigraphy",
      "71-ultrasound-spotting",
      "71-anaesthetist-consultation",
      "71-abdominal-ultrasound",
      "71-echocardiography",
      "71-mri",
      "71-mammography",
      "71-preoperative-nurse-appointment",
      "71-scanner",
      "71-tracking-scanner",
      "71-bone-scan",
      "71-computed-tomography",
      "71-addictologist",
      "71-respiratory-kine",
      "71-dentist",
      "71-psychologist",
      "71-social-worker"
    ],
    "onco-brain-cancer": [
      "71-announcement-consultation",
      "71-sentinel-node-lymphoscinthigraphy",
      "71-ultrasound-spotting",
      "71-anaesthetist-consultation",
      "71-abdominal-ultrasound",
      "71-echocardiography",
      "71-mri",
      "71-mammography",
      "71-preoperative-nurse-appointment",
      "71-scanner",
      "71-tracking-scanner",
      "71-bone-scan",
      "71-computed-tomography",
      "71-addictologist",
      "71-respiratory-kine",
      "71-dentist",
      "71-psychologist",
      "71-social-worker"
    ],
    "onco-stomach-cancer": [
      "71-announcement-consultation",
      "71-sentinel-node-lymphoscinthigraphy",
      "71-ultrasound-spotting",
      "71-anaesthetist-consultation",
      "71-abdominal-ultrasound",
      "71-echocardiography",
      "71-mri",
      "71-mammography",
      "71-preoperative-nurse-appointment",
      "71-scanner",
      "71-tracking-scanner",
      "71-bone-scan",
      "71-computed-tomography",
      "71-addictologist",
      "71-respiratory-kine",
      "71-dentist",
      "71-psychologist",
      "71-social-worker"
    ],
    "onco-kidney-cancer": [
      "71-announcement-consultation",
      "71-sentinel-node-lymphoscinthigraphy",
      "71-ultrasound-spotting",
      "71-anaesthetist-consultation",
      "71-abdominal-ultrasound",
      "71-echocardiography",
      "71-mri",
      "71-mammography",
      "71-preoperative-nurse-appointment",
      "71-scanner",
      "71-tracking-scanner",
      "71-bone-scan",
      "71-computed-tomography",
      "71-addictologist",
      "71-respiratory-kine",
      "71-dentist",
      "71-psychologist",
      "71-social-worker"
    ],
    "onco-hemato-cancer": [
      "71-announcement-consultation",
      "71-sentinel-node-lymphoscinthigraphy",
      "71-ultrasound-spotting",
      "71-anaesthetist-consultation",
      "71-abdominal-ultrasound",
      "71-echocardiography",
      "71-mri",
      "71-mammography",
      "71-preoperative-nurse-appointment",
      "71-scanner",
      "71-tracking-scanner",
      "71-bone-scan",
      "71-computed-tomography",
      "71-addictologist",
      "71-respiratory-kine",
      "71-dentist",
      "71-psychologist",
      "71-social-worker"
    ],
    "onco-cervix-cancer": [
      "71-announcement-consultation",
      "71-sentinel-node-lymphoscinthigraphy",
      "71-ultrasound-spotting",
      "71-anaesthetist-consultation",
      "71-abdominal-ultrasound",
      "71-echocardiography",
      "71-mri",
      "71-mammography",
      "71-preoperative-nurse-appointment",
      "71-scanner",
      "71-tracking-scanner",
      "71-bone-scan",
      "71-computed-tomography",
      "71-addictologist",
      "71-respiratory-kine",
      "71-dentist",
      "71-psychologist",
      "71-social-worker"
    ],
    "onco-skin-cancer": [
      "71-announcement-consultation",
      "71-sentinel-node-lymphoscinthigraphy",
      "71-ultrasound-spotting",
      "71-anaesthetist-consultation",
      "71-abdominal-ultrasound",
      "71-echocardiography",
      "71-mri",
      "71-mammography",
      "71-preoperative-nurse-appointment",
      "71-scanner",
      "71-tracking-scanner",
      "71-bone-scan",
      "71-computed-tomography",
      "71-addictologist",
      "71-respiratory-kine",
      "71-dentist",
      "71-psychologist",
      "71-social-worker"
    ],
    "onco-liver-cancer": [
      "71-announcement-consultation",
      "71-sentinel-node-lymphoscinthigraphy",
      "71-ultrasound-spotting",
      "71-anaesthetist-consultation",
      "71-abdominal-ultrasound",
      "71-echocardiography",
      "71-mri",
      "71-mammography",
      "71-preoperative-nurse-appointment",
      "71-scanner",
      "71-tracking-scanner",
      "71-bone-scan",
      "71-computed-tomography",
      "71-addictologist",
      "71-respiratory-kine",
      "71-dentist",
      "71-psychologist",
      "71-social-worker"
    ],
    "onco-breast-cancer-tnm0": [
      "71-ecg-consultation",
      "71-anaesthetist-consultation",
      "71-announcement-consultation",
      "71-sentinel-node-lymphoscinthigraphy",
      "71-intervention",
      "71-surgery-post-consultation",
      "71-oncology-consultation",
      "71-targeted-therapy-end-date",
      "71-targeted-therapy-start-date",
      "71-chemotherapy-therapy-one",
      "71-chemotherapy-therapy-two",
      "71-chemotherapy-therapy-four",
      "71-chemotherapy-therapy-five",
      "71-radiotherapy-consultation",
      "71-radiotherapy-start-date",
      "71-radiotherapy-end-date",
      "71-hormonotherapy-start-date",
      "71-hormonotherapy-end-date",
      "71-cp-appointment"
    ],
    "onco-breast-cancer": [
      "71-ecg-consultation",
      "71-anaesthetist-consultation",
      "71-announcement-consultation",
      "71-sentinel-node-lymphoscinthigraphy",
      "71-intervention",
      "71-surgery-post-consultation",
      "71-oncology-consultation",
      "71-targeted-therapy-end-date",
      "71-targeted-therapy-start-date",
      "71-chemotherapy-therapy-one",
      "71-chemotherapy-therapy-two",
      "71-chemotherapy-therapy-four",
      "71-chemotherapy-therapy-five",
      "71-radiotherapy-consultation",
      "71-radiotherapy-start-date",
      "71-radiotherapy-end-date",
      "71-hormonotherapy-start-date",
      "71-hormonotherapy-end-date",
      "71-cp-appointment"
    ],
    "onco-lung-cancer": [
      "71-announcement-consultation",
      "71-sentinel-node-lymphoscinthigraphy",
      "71-ultrasound-spotting",
      "71-anaesthetist-consultation",
      "71-abdominal-ultrasound",
      "71-echocardiography",
      "71-mri",
      "71-mammography",
      "71-preoperative-nurse-appointment",
      "71-scanner",
      "71-tracking-scanner",
      "71-bone-scan",
      "71-computed-tomography",
      "71-addictologist",
      "71-respiratory-kine",
      "71-dentist",
      "71-psychologist",
      "71-social-worker",
      "71-cure-injection",
      "71-re-evaluation-scanner"
    ],
    "onco-prostate-cancer": [
      "71-announcement-consultation",
      "71-sentinel-node-lymphoscinthigraphy",
      "71-ultrasound-spotting",
      "71-anaesthetist-consultation",
      "71-abdominal-ultrasound",
      "71-echocardiography",
      "71-mri",
      "71-mammography",
      "71-preoperative-nurse-appointment",
      "71-scanner",
      "71-tracking-scanner",
      "71-bone-scan",
      "71-computed-tomography",
      "71-addictologist",
      "71-respiratory-kine",
      "71-dentist",
      "71-psychologist",
      "71-social-worker",
      "71-remove-urinary-catheter",
      "71-post-operative-consultation",
      "71-follow-up-consultation"
    ],
    "onco-pancreatic-cancer": [
      "71-announcement-consultation",
      "71-sentinel-node-lymphoscinthigraphy",
      "71-ultrasound-spotting",
      "71-anaesthetist-consultation",
      "71-abdominal-ultrasound",
      "71-echocardiography",
      "71-mri",
      "71-mammography",
      "71-preoperative-nurse-appointment",
      "71-scanner",
      "71-tracking-scanner",
      "71-bone-scan",
      "71-computed-tomography",
      "71-addictologist",
      "71-respiratory-kine",
      "71-dentist",
      "71-psychologist",
      "71-social-worker",
      "71-primo-prescription",
      "71-medication-reconciliation",
      "71-multiparty-consultation",
      "71-follow-up-consultation-with-prescription-renewal"
    ],
    "onco-generic": [
      "71-announcement-consultation",
      "71-anaesthetist-consultation",
      "71-echocardiography",
      "71-mri",
      "71-psychologist",
      "71-social-worker"
    ]
  };

  Object.entries(followUpReasonAllowedTypes).forEach(
    ([followUpReasonId, allowedTypesId]) => {
      const followUpReason = store.peekRecord(
        "follow-up-reason",
        followUpReasonId
      );
      const allowedTypesRecords: ConsultationAllowedType[] = [];
      allowedTypesId.forEach(id => {
        allowedTypesRecords.push(consultationAllowedTypesRecords[id]);
      });
      followUpReason!.consultationAllowedTypes = allowedTypesRecords;
    }
  );
}

export default {
  after: "follow-up-reasons",
  initialize
};
